import React from 'react';
import CloseIcon from '../../../../ui/svg/common/close';
import { useDispatch } from 'react-redux';
import { rootActions } from '../data/store';

const TopPanel = () => {

    const dispatch = useDispatch();

    const close = () => {
        dispatch(
            rootActions.main({
                isOpened: false,
            })
        )
    };

    return (
        <section className="flex items-center justify-between px-6 py-3">

            <p className="font-medium">Search</p>

            <button
                type="button"
                title="Close"
                onClick={ close }>
                <CloseIcon width="16" color="#828282" />
            </button>
        </section>
    )
};

export default TopPanel;